import React from 'react';
import { useSelector } from 'react-redux';
import { Droppable, Draggable } from "react-beautiful-dnd";
import ListingCard from '../Components/ListingCard';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';

const RenderKeywordListing = ({ keyword, id, addKeywordLisitng }) => {
    const listings_data = useSelector((state) => state.webpage_detail.listings);

    return (
        <Droppable droppableId={id} type={`LISTINGS_${keyword.keyword}`}>
            {(provided) => {
                return (
                    <>
                        <div ref={provided.innerRef}>
                            {listings_data.listings_data?.listings?.filter((listing) => listing.keywords.includes(keyword.keyword)).map((item, index) => {
                                return (
                                    <Draggable
                                        key={`listing-${item.listing_id}`}
                                        draggableId={`listing-${item.listing_id}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <>
                                                <div ref={provided.innerRef} {...provided.draggableProps} className={`col-12 bottom_margin`}>
                                                    <ListingCard can_remove_keyword item={item} index={index} provided={provided} />
                                                </div>
                                                {provided.placeholder}
                                            </>
                                        )}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}

                            {listings_data.plans_data?.plans?.filter((plan) => plan.tag.includes(keyword.keyword)).map((item, index) => {
                                return (
                                    <div className={`col-12 bottom_margin`}>
                                        <ListingCard can_remove_keyword item={item} index={index} />
                                    </div>
                                )
                            })}

                            <div onClick={() => addKeywordLisitng(keyword)} className={`ml-2 mb-2 row no-gutters`}><h6 className={`action_text mr-2`}>Add listings</h6><AddCircleOutlinedIcon style={{ fill: '#493AB1' }} /></div>
                        </div>
                    </>
                );
            }}
        </Droppable>
    )
}

export default RenderKeywordListing;